<template>
  <modal
    id="modalHistoricoLancamento"
    :exibir="exibir"
    titulo="FINANCEIRO.HISTORICO_LANCAMENTO"
    :campos="$refs"
    @fechar="fecharModal"
  >
    <form-historico :form="form" @refs="capturarRefs" />
    <template #modal-footer>
      <div class="d-flex justify-content-between w-100">
        <b-button variant="secondary" @click="fecharModal">
          {{ $t('GERAL.FECHAR') }}
        </b-button>
        <b-button variant="primary" @click="criar">
          {{ $t('GERAL.SALVAR') }}
        </b-button>
      </div>
    </template>
  </modal>
</template>
<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';

// Services:
import HistoricoLancamentoService from '@/common/services/historico-lancamento/historico-lancamento.service.js';

// Components:
import Modal from '@/components/modal/Modal';
import FormHistorico from './Form';

export default {
  props: {
    exibir: { type: Boolean, default: false },
    form: { type: Object, default: Object },
  },
  components: {
    Modal,
    FormHistorico,
  },
  data() {
    return {
      refs: [],
    };
  },
  // watch: {
  //   form() {},
  // },
  methods: {
    criar() {
      this.$store.dispatch(START_LOADING);
      HistoricoLancamentoService.criar(this.form)
        .then(() => {
          this.$emit('atualizar-tabela');
          mensagem.sucesso(this.$t('GERAL.SUCESSO'));
          this.fecharModal();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.fecharModal();
          this.$store.dispatch(STOP_LOADING);
        });
    },
    // FUNÇÕES MODAL:
    fecharModal() {
      this.$emit('fechar', 'historico');
    },
    // FUNÇÕES AUXILIARES:
    validarFormulario() {
      return helpers.validarFormulario(this.refs);
    },
    capturarRefs(refs) {
      this.refs = refs;
    },
  },
};
</script>
